export default {
    plotlyUrl: "#{plotlyUrl}#",
    priApplicationURL: "#{priApplicationURL}#",
    registerUrl: "#{registerUrl}#"
}